/*
 * @title: 
 * @Author: wangshuai
 * @Date: 2024-10-30 15:46:32
 * @FilePath: \飞行-运控\src\api\model\settled.js
 * @Description: 企业入驻模块接口
 * 
 */
import config from "@/config";
import http from "@/utils/request";

export default {
	queryStationInfo: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/queryStationInfo`,
		name: "企业入驻-申请服务站列表",
		get: async function () {
			return await http.get(this.url);
		},
	},
	addJoinServiceStation: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/addJoinServiceStation`,
		name: "企业入驻-入驻申请",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
	queryJoinServiceStation: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/queryJoinServiceStation`,
		name: "企业入驻-获取入驻审核列表",
		get: async function (data) {
			return await http.post(this.url,data);
		},
	},
	queryJoinHistoricalRecords: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/queryJoinHistoricalRecords`,
		name: "企业入驻-获取审核历史记录",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	queryAgreement: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/queryAgreement`,
		name: "企业入驻-获取协议详情",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	updateAgreement: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/updateAgreement`,
		name: "企业入驻-签署协议",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
	queryRegistrationTerms: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/queryRegistrationTerms`,
		name: "企业入驻-获取申请服务站协议",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
};
